//BV - Business Vertical
var keys = {
    BV_advertising: "BV_advertising",
    BV_automotive: "BV_automotive",
    BV_beauty: "BV_beauty",
    BV_clothing: "BV_clothing",
    BV_consumer_goods: "BV_consumer_goods",
    BV_ecommerce: "BV_ecommerce",
    BV_education: "BV_education",
    BV_energy: "BV_energy",
    BV_entertainment: "BV_entertainment",
    BV_entertainment_media: "BV_entertainment_media",
    BV_event_planning: "BV_event_planning",
    BV_banking: "BV_banking",
    BV_food: "BV_food",
    BV_gaming: "BV_gaming",
    BV_government: "BV_government",
    BV_hotel: "BV_hotel",
    BV_IT: "BV_IT",
    BV_marketing: "BV_marketing",
    BV_medical: "BV_medical",
    BV_non_profit: "BV_non_profit",
    BV_organizations: "BV_organizations",
    BV_other: "BV_other",
    BV_professional: "BV_professional",
    BV_public: "BV_public",
    BV_retail: "BV_retail",
    BV_restaurant: "BV_restaurant",
    BV_shopping: "BV_shopping",
    BV_technology: "BV_technology",
    BV_telecom: "BV_telecom",
    BV_travel: "BV_travel",
    BV_transportation: "BV_transportation",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsd0JBQXdCO0FBQ3hCLElBQU0sSUFBSSxHQUE0QjtJQUNwQyxjQUFjLEVBQUUsZ0JBQWdCO0lBQ2hDLGFBQWEsRUFBRSxlQUFlO0lBQzlCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLFdBQVcsRUFBRSxhQUFhO0lBQzFCLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxZQUFZLEVBQUUsY0FBYztJQUM1QixZQUFZLEVBQUUsY0FBYztJQUM1QixTQUFTLEVBQUUsV0FBVztJQUN0QixnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsc0JBQXNCLEVBQUUsd0JBQXdCO0lBQ2hELGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxVQUFVLEVBQUUsWUFBWTtJQUN4QixPQUFPLEVBQUUsU0FBUztJQUNsQixTQUFTLEVBQUUsV0FBVztJQUN0QixhQUFhLEVBQUUsZUFBZTtJQUM5QixRQUFRLEVBQUUsVUFBVTtJQUNwQixLQUFLLEVBQUUsT0FBTztJQUNkLFlBQVksRUFBRSxjQUFjO0lBQzVCLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLGFBQWEsRUFBRSxlQUFlO0lBQzlCLGdCQUFnQixFQUFFLGtCQUFrQjtJQUNwQyxRQUFRLEVBQUUsVUFBVTtJQUNwQixlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLGFBQWEsRUFBRSxlQUFlO0lBQzlCLFdBQVcsRUFBRSxhQUFhO0lBQzFCLGFBQWEsRUFBRSxlQUFlO0lBQzlCLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLGlCQUFpQixFQUFFLG1CQUFtQjtDQUN2QyxDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==